const getUserPreferences = (rootState) => rootState.user.userPreferences;

export default getUserPreferences;
